export const LOAD_PAID_SERVICE_REQUESTS = "LOAD_PAID_SERVICE_REQUESTS"
export const loadPaidServiceRequestsAction = serviceRequestsPagination => ({
   type: LOAD_PAID_SERVICE_REQUESTS,
   payload: serviceRequestsPagination
})